import React from 'react';

const CategoriesPage = React.lazy(() => import('./CategoriesPage'));

const CategoriesConfig = {
	settings: {
		layout: {
			config: {},
		},
	},
	routes: [
		{
			path: '/billing/categories',
			element: (
				<React.Suspense fallback={<>...</>}>
					<CategoriesPage />
				</React.Suspense>
			),
		},
	],
	auth: ['school_admin', 'super_school_admin', 'sub_admin'],
};

export default CategoriesConfig;
